import { DialogComponent } from '@theme/dialog';

class VideoPlayModal extends DialogComponent {
  showDialog() {
    super.showDialog();
    const video = this.querySelector('video');
    if (video) {
      video.play().catch(() => {});
    }
  }

  closeDialog = async () => {
    const video = this.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    return super.closeDialog();
  };
}

if (!customElements.get('video-play-modal')) {
  customElements.define('video-play-modal', VideoPlayModal);
}
